// Máscara de dinheiro no padrão brasileiro para campos de input.
//
// Funciona por CENTAVOS, que é o comportamento que o usuário espera de campo
// financeiro: ele digita os números e a vírgula se posiciona sozinha, da direita
// para a esquerda. Digitar "12345" mostra "123,45"; "1234567" mostra "12.345,67".
// Assim não existe estado inválido no meio da digitação (nem "1,2,3" nem "12,3").

const MAX_DIGITOS = 13; // até 99.999.999.999,99

// Valor digitado -> texto formatado para exibir no input.
export function mascaraMoedaBR(valor: string): string {
  const digitos = valor.replace(/\D/g, '').replace(/^0+(?=\d)/, '').slice(0, MAX_DIGITOS);
  if (!digitos) return '';
  return (Number(digitos) / 100).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

// Texto do input (mascarado ou não) -> número, para enviar na API.
export function moedaParaNumero(valor: string): number {
  const digitos = (valor || '').replace(/\D/g, '');
  return digitos ? Number(digitos) / 100 : 0;
}

// Número -> texto para PREENCHER o input já mascarado (ex.: edição de registro).
export function numeroParaMascaraMoeda(valor: number | string | null | undefined): string {
  const n = Number(valor);
  if (!Number.isFinite(n) || n === 0) return '';
  return mascaraMoedaBR(String(Math.round(n * 100)));
}

// Quantidade aceita decimal com vírgula ou ponto (não é dinheiro: não usa centavos).
export function quantidadeParaNumero(valor: string): number {
  const limpo = (valor || '').replace(/\./g, '').replace(',', '.').replace(/[^\d.]/g, '');
  const n = Number(limpo);
  return Number.isFinite(n) ? n : 0;
}
